export default "__VITE_ASSET__AIA2jp1C__"